import { getActivePinia } from 'pinia'

const Key = Symbol('rpcapi')
export function setRpcapi (pinia, rpcapi) {
  pinia[Key] = rpcapi
}

export function useRpcapi () {
  return getActivePinia()[Key]
}

const AuthKey = Symbol('auth')

export function setAuth (pinia, auth) {
  pinia[AuthKey] = auth
}

export function useAuth () {
  return getActivePinia()[AuthKey]
}
